import React from 'react';
import { Modal } from 'antd';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { Store } from '../Ui';


const IDs = [`National ID`, `NPI`, `Farmer ID`, `Driver's Licence`];
const initialValues = {
    name: '',
    id_type: '',
    id_number: '',
};
const Director = ({ visible, row, onSuccess, onCancel }) => {

    const { setUtils } = React.useContext(Store);

    const [m, setMethod] = React.useState('');
    const [title, setTitle] = React.useState('');

    React.useEffect(() => {
        if (row && row.id) {
            setTitle('Modifier Directeur');
            setMethod('put');
            formik.setValues({
                ...initialValues,
                ...row,
            });
        } else {
            setTitle('Nouveau Directeur');
            setMethod('post');
        }
    }, [row]);

    const close = () => {
        formik.resetForm();
        onCancel();
    }

    const validationSchema = yup.object({
        name: yup.string().required('Non valide, réessayer'),
        id_type: yup.string().required('Non valide, réessayer'),
        id_number: yup.number().required('Non valide, réessayer'),
    });
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (v) => {
            setUtils('loading', { spinning: true, primary: 'Directeur en cours de création' });
            setTimeout(() => {
                close();
                onSuccess(m, v);
                setUtils('loading', { spinning: false, primary: '', });
            }, 800);
        },
    });

    return (
        <React.Fragment>
            <Modal visible={visible} width={500} title={title} centered footer={null} onCancel={close}>
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-4">
                        <FormControl fullWidth>
                            <TextField
                                name="name" label="Nom Complet"
                                value={formik.values.name}
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && formik.errors.name}
                                onChange={formik.handleChange}
                            />
                        </FormControl>
                    </div>
                    <div className="mb-4">
                        <FormControl fullWidth error={formik.touched.id_type && Boolean(formik.errors.id_type)}>
                            <InputLabel>Type de Pièce d'identité</InputLabel>
                            <Select
                                name="id_type" label="Type de Pièce d'identité"
                                value={formik.values.id_type}
                                onChange={formik.handleChange}
                            >
                                {IDs.map(ID => (
                                    <MenuItem key={ID} value={ID}>{ID}</MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>{formik.touched.id_type && formik.errors.id_type}</FormHelperText>
                        </FormControl>
                    </div>
                    <div className="mb-4">
                        <FormControl fullWidth>
                            <TextField
                                name="id_number" label="N° de la pièce d'identité" type="number"
                                value={formik.values.id_number}
                                error={formik.touched.id_number && Boolean(formik.errors.id_number)}
                                helperText={formik.touched.id_number && formik.errors.id_number}
                                onChange={formik.handleChange}
                            />
                        </FormControl>
                    </div>


                    <p className="mt-4">&nbsp;</p>
                    <div className="flex justify-between">
                        <Button size="large" variant="outlined" disableElevation color="secondary" onClick={close}>
                            Annuler
                        </Button>
                        <Button size="large" variant="outlined" disableElevation color="success" type="submit">
                            {m === 'post' ? 'Ajouter' : 'Modifier'}
                        </Button>
                    </div>
                </form>
            </Modal>
        </React.Fragment>
    );
}

export default Director;